import { z } from 'zod'

import { isJunkParamValue } from '@/utils/urlParamHygiene'

export type EntitySearch = Record<string, string | string[]>

// Preserve text (including numeric-looking IDs) and repeated query parameters.
export function parseSearch(search: string): EntitySearch {
  const result: EntitySearch = {}
  for (const [key, value] of new URLSearchParams(search)) {
    if (isJunkParamValue(value)) continue
    const previous = result[key]
    result[key] =
      previous === undefined
        ? value
        : [...(Array.isArray(previous) ? previous : [previous]), value]
  }
  return result
}

export function stringifySearch(search: Record<string, unknown>): string {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(search)) {
    for (const item of Array.isArray(value) ? value : [value]) {
      if (typeof item === 'string' && !isJunkParamValue(item)) {
        params.append(key, item)
      }
    }
  }
  const query = params.toString()
  return query ? `?${query}` : ''
}

// Attribute filters and time-tracking fields are schema-defined by the API.
// Validate their values without maintaining a second registry of schema fields.
export const entitySearchSchema = z
  .record(z.string(), z.union([z.string(), z.array(z.string())]))
  .transform((params) => parseSearch(stringifySearch(params)))
